import React from 'react';
import { chart } from './chartTheme';

/**
 * Horizontal response funnel — each stage a proportional teal bar with step
 * conversion. Ported verbatim from
 * D:\campaigning-system\src\components\charts\Funnel.tsx (types stripped).
 * `data`: Array<{ stage: string, value: number }>.
 */
export function Funnel({ data, className = '' }) {
  if (!data || data.length === 0) return null;
  const top = data[0].value;

  return (
    <div className={`space-y-2.5 ${className}`}>
      {data.map((d, i) => {
        const pctOfTop = top ? (d.value / top) * 100 : 0;
        const stepConv = i === 0 ? 100 : data[i - 1].value ? (d.value / data[i - 1].value) * 100 : 0;
        return (
          <div key={d.stage} className="group">
            <div className="mb-1 flex items-baseline justify-between text-[13px]">
              <span className="font-medium text-cos-ink-secondary">{d.stage}</span>
              <span className="flex items-baseline gap-2">
                <span className="mono font-semibold text-cos-ink">{d.value.toLocaleString('en-IN')}</span>
                {/* A stage may name its own denominator: a bounce is not a conversion from the
                    stage above it, and reporting it as one reads as a rate nobody meant. */}
                {d.pctLabel ? (
                  <span className="mono text-2xs text-cos-ink-muted">{d.pctLabel}</span>
                ) : (
                  i > 0 && <span className="mono text-2xs text-cos-ink-muted">{stepConv.toFixed(0)}%</span>
                )}
              </span>
            </div>
            <div className="h-6 overflow-hidden rounded-lg bg-[rgba(70,80,72,0.06)]">
              <div
                className="flex h-full items-center justify-end rounded-lg pr-2 transition-[width] duration-700"
                style={{
                  width: `${Math.max(pctOfTop, 6)}%`,
                  background: d.tone === 'alarm'
                    ? 'linear-gradient(90deg, #C98B7E, #A35A4E)'
                    : `linear-gradient(90deg, ${chart.ramp[Math.min(i, chart.ramp.length - 1)]}, ${chart.tealDeep})`,
                }}
              >
                <span className="mono text-2xs font-semibold text-white/90">{pctOfTop.toFixed(0)}%</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Funnel;
